angular.module('galilai.creator').controller('FavoritesController', function($scope, $timeout, $rootScope, $http, $location, api) {

})

